import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/api';

export const fetchSiteAlert = createAsyncThunk(
  'siteAlert/fetch',
  async () => {
    const res = await apiFetch('/api/public/marketing/site-alert/');
    if (!res.ok) throw new Error(`Server error: ${res.status}`);
    const data = await res.json();
    return {
      isEnabled: !!data.is_enabled,
      message: data.message || '',
    };
  }
);

const siteAlertSlice = createSlice({
  name: 'siteAlert',
  initialState: {
    isEnabled: false,
    message: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSiteAlert.fulfilled, (state, action) => {
      state.isEnabled = action.payload.isEnabled;
      state.message = action.payload.message;
    });
  },
});

export const selectSiteAlertMessage = (state) => state.siteAlert.message;
export const selectSiteAlertActive = (state) =>
  state.siteAlert.isEnabled && state.siteAlert.message.trim() !== '';

export default siteAlertSlice.reducer;
